import React, { useState } from "react";
import AddSite from "../../library/AddSite/AddSite";
import { addSideReducer, mapDispatchToProps } from "./AddSite.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

export const SmartAddSite = (props) => {
  const { studyId, addSite, onClose, SiteButton, greenTheme } = props;

  const [hasError, setHasError] = useState(false);

  const onSubmit = (site) => {
    setHasError(false);

    addSite(site, studyId)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        setHasError(true);
        sendNotification(error, ToastType.ERROR);
      });
  };

  return (
    <AddSite
      onSubmit={onSubmit}
      SiteButton={SiteButton}
      greenTheme={greenTheme}
      {...{ hasError }}
    />
  );
};

export default dynamic(
  "addSideReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(addSideReducer)
)(connect(null, mapDispatchToProps)(SmartAddSite));
